import { MOCK_CURRENT_USER_PROFILE } from '@/features/profile/mockData';
import type { ProfileEditDraft, ProfileFieldLocks } from '@/features/profile/edit/types';
import { splitFullName } from '@/features/profile/edit/profileEditUtils';

/** Demo: username and institution locked by admin; names remain editable. */
export const DEFAULT_PROFILE_FIELD_LOCKS: ProfileFieldLocks = {
  firstName: true,
  lastName: true,
  username: true,
  institution: true,
};

export function createDefaultProfileEditDraft(): ProfileEditDraft {
  const { firstName, lastName } = splitFullName(MOCK_CURRENT_USER_PROFILE.name);

  return {
    firstName,
    lastName,
    username: MOCK_CURRENT_USER_PROFILE.username,
    institution: MOCK_CURRENT_USER_PROFILE.institution,
    bio: '',
    email: MOCK_CURRENT_USER_PROFILE.email,
    mobile: '+1 555 010 2244',
    gender: 'prefer_not_to_say',
    dateOfBirth: '1988-03-14',
    avatarUrl: MOCK_CURRENT_USER_PROFILE.avatarUrl,
    bannerUrl: MOCK_CURRENT_USER_PROFILE.bannerUrl,
    fieldLocks: DEFAULT_PROFILE_FIELD_LOCKS,
  };
}
